<template>
  <div :class="[$style['adl-mds-editable-datatable'], $style['GroupWrap']]">
    <div v-if="tableHeadingName" :class="$style['mds-card__label']">
      <!-- <div :class="$style['mds-card__label-title']"> {{datatableDetails.tableHeadingName}} </div> -->

      <div :class="$style['mds-card__title']">
        <slot>{{ tableHeadingName }}</slot>
      </div>
    </div>
    <div :class="$style['adl-mds-data-table']">
      <mds-table v-if="getRows.length > 1">
        <mds-thead>
          <mds-th
            v-for="(header, headerIndex) in headers"
            :key="headerIndex"
            :style="header.style"
            :class="[
              $style['tableheader'],
              header.customClassName ? $style[header.customClassName] : '',
            ]"
          >
            {{ header.headerName }}
          </mds-th>
        </mds-thead>
        <mds-tbody>
          <mds-tr
            :class="$style['tablerow']"
            v-for="(row, index) in getRows"
            :key="index"
            v-bind:total-row="row.isShowTotal"
          >
            <mds-td
              v-for="(header, headerIndex) in headers"
              :key="headerIndex"
              :style="header.styleRow"
              :class="$style['tablecell']"
            >
              <template v-if="header.fieldType == 'text'">
                <div
                  v-if="header.isShowTotal && row.isShowTotal"
                  :class="$style['totalRowBalanceCell']"
                >
                  {{ totalAmount[headerIndex] }}
                </div>
                <div
                  v-if="!row.isEditMode || !header.isEditable"
                  :class="header.isEditable ? $style['editableCellLabel'] : ''"
                >
                  {{
                    row[header.formattedCurrencyLabel]
                      ? row[header.formattedCurrencyLabel]
                      : row[header.rowPropName]
                  }}
                </div>
                <!-- <div v-else-if="!header.isShowTotal && !header.isEditable && !row.isEditMode" :class="$style['editableCellLabel']">
                    {{row.isEditMode }}{{ row[header.rowPropName] }}
                  </div> -->
                <div
                  v-if="header.isEditable == true && !row.isShowTotal"
                  :class="!row.isEditMode ? $style['editableCellTxtbox'] : ''"
                >
                  <adl-input-format
                    :hideLabel="true"
                    :label="hidden"
                    :isDisabled="row[header.disablePropName]"
                    :currencyFormat="header.currencyFormat"
                    :value="row[header.rowPropName]"
                    v-model="row[header.rowPropName]"
                    :maxlength="header.maxlength"
                    :isAllowOnlyNumber="header.isAllowOnlyNumber"
                    :AllowOnlyDecimalTill="header.AllowOnlyDecimalTill"
                    :class="$style['editableTextBox']"
                    :maxvalue="9999999999"
                    :istextRightAligned="header.isEditableTextBoxRightAligned"
                    @focusin.native="addSelected(row)"
                    @focusout.native="
                      removeSelected(
                        row,
                        header,
                        row[header.blurValidationPropName]
                      );
                      $emit('eventActionHandler', header.focusoutEvent, row);
                    "
                    @input.native="
                      $emit('eventActionHandler', header.inputActionEvent, row)
                    "
                    @keyup.native="
                      $emit(
                        'eventActionHandler',
                        header.keypressActionEvent,
                        row
                      )
                    "
                  ></adl-input-format>
                </div>
              </template>
              <template
                v-else-if="
                  header.fieldType == 'textwithimage' && row.isShowTotal
                "
              >
                <div>
                  {{ row[header.rowPropName] }}
                </div>
              </template>
              <template v-else-if="header.fieldType == 'textwithimage'">
                <div style="min-height: 35px">
                  <div
                    v-if="
                      header.isEditable && row[header.editableBasedOnProp] == ''
                    "
                    :class="[
                      !row.isEditMode && row[header.editableBasedOnProp] == ''
                        ? $style['editableCellTxtbox']
                        : '',
                      $style['textwithimagesection'],
                    ]"
                  >
                    {{ row[header.editableBasedOnProp] }}
                    <adl-input-format
                      :placeholder="header.placeholder"
                      :hideLabel="true"
                      :label="hidden"
                      :isDisabled="false"
                      :value="row[header.rowPropName]"
                      v-model="row[header.rowPropName]"
                      :maxlength="header.maxlength"
                      :isAllowOnlyNumber="false"
                      @focusin.native="addSelected(row)"
                      @focusout.native="
                        removeSelected(row, undefined, row[header.rowPropName])
                      "
                    ></adl-input-format>
                  </div>
                  <div
                    v-if="
                      !row.isEditMode || row[header.editableBasedOnProp] != ''
                    "
                    :class="[
                      row[header.editableBasedOnProp] == ''
                        ? $style['editableCellLabel']
                        : '',
                      $style['textLogoWrapper'],
                    ]"
                  >
                    <div :class="$style['cf-profileInitialsWrapper']">
                      <span :class="$style['cf-profileInitials']">
                        {{ getSuperInitial(row[header.rowPropName]) }}
                      </span>
                    </div>
                    <div style="margin-left: 8px">
                      {{ row[header.rowPropName] }}
                    </div>
                  </div>
                </div>
              </template>
              <template
                v-else-if="header.fieldType == 'checkbox' && !row.isShowTotal"
              >
                <div>
                  <mds-checkbox
                    hidden-label
                    v-model="row[header.rowPropName]"
                  ></mds-checkbox>
                </div>
              </template>
              <template
                v-else-if="header.fieldType == 'tag' && !row.isShowTotal"
              >
                <div :class="$style['cf-tag']">
                  <mds-tag
                    on-black
                    :class="$style['cf-tag-inner']"
                    v-if="row[header.rowPropName] != ''"
                  >
                    {{ row[header.rowPropName] }}
                  </mds-tag>
                </div>
              </template>

              <template
                v-else-if="header.fieldType == 'action' && !row.isShowTotal"
                v-for="action in header.actions"
              >
                <mds-button
                  v-if="row[action.showActionBasedOnProp]"
                  variation="icon-only"
                  :icon="action.icon"
                  size="small"
                  type="button"
                  @click="
                    $emit('eventActionHandler', action.emitevent, {
                      allrows: rowsData,
                      selectedRow: row,
                    })
                  "
                  @mouseover="row.toggle = true"
                  @mouseleave="row.toggle = false"
                  @focus="row.toggle = true"
                  @blur="row.toggle = false"
                  :id="'default-trigger' + tableHeadingName + index"
                >
                  label
                </mds-button>
                <mds-tooltip
                  v-if="row[action.showActionBasedOnProp]"
                  :position="action.position"
                  :triggered-by="'default-trigger' + tableHeadingName + index"
                  v-model="row.toggle"
                >
                  {{ action.toolTipText }}
                </mds-tooltip>
              </template>
            </mds-td>
          </mds-tr>
          <mds-tr>
            <mds-button
              variation="flat"
              icon-right="plus"
              @click.native="addBlankRow({ allrows: rowsData })"
            >
              Add New
            </mds-button>
          </mds-tr>
        </mds-tbody>
      </mds-table>
    </div>
    <div v-if="getRows.length == 1" :class="$style['cf-blank-Results']">
      <mds-empty-state
        :title="emptyStateTitle"
        :message="emptyStateMessage"
        size="medium"
      >
        <template #mds-empty-state-actions>
          <mds-button
            variation="flat"
            icon-right="plus"
            @click.native="addBlankRow({ allrows: rowsData })"
          >
            Add New
          </mds-button>
        </template>
      </mds-empty-state>
    </div>
  </div>
</template>
<script>
import {
  MdsTable,
  MdsThead,
  MdsTh,
  MdsTbody,
  MdsTr,
  MdsTd,
} from "@mds/data-table";
import { MdsInput } from "@mds/input";
import { MdsButton } from "@mds/button";
import MdsCheckbox from "@mds/checkbox";
import MdsTooltip from "@mds/tooltip";
import { MdsTag, MdsTagContainer } from "@mds/tag";
import MdsEmptyState from "@mds/empty-state";
import AdlInputFormat from "../input-format/InputFormat.vue";
import _ from "lodash";
import { format } from "d3-format";
export default {
  inheritAttrs: false,

  props: {
    emptyStateTitle: {
      type: String,
      default: "",
    },
    emptyStateMessage: {
      type: String,
      default: "",
    },
    headers: {
      type: Array,
    },
    rows: {
      type: Array,
    },
    showEmptyState: {
      type: Boolean,
      default: false,
    },
    tableHeadingName: {
      type: String,
    },
    groupType: {
      type: Number,
    },
    parentGroupId: {
      type: Number,
    },
  },
  data() {
    return {
      rowsData: this.rows,
      hidden: "hidden",
    };
  },
  components: {
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    MdsCheckbox,
    MdsEmptyState,
    MdsTag,
    MdsTagContainer,
    AdlInputFormat,
    MdsButton,
    MdsInput,
    MdsTooltip,
  },
  computed: {
    getRows() {
      return this.rowsData.filter((m) => !m.isDeleted);
    },
    totalAmount() {
      this.headers.map((header, i) => {
        if (header.isShowTotal) {
          let amount = 0;
          if (header.sumPropName) {
            amount += this.rowsData
              .filter((m) => !m.isShowTotal && !m.isDeleted)
              .reduce(
                (a, b) =>
                  a +
                  (b[header.sumPropName] == ""
                    ? 0
                    : parseFloat(b[header.sumPropName])),
                0
              );
          }
          this.rowsData.filter((m) => m.isShowTotal)[0].amounts[i] = format(
            header.currencyFormat
          )(amount);
        }
      });
      return this.rowsData.filter((m) => m.isShowTotal)[0].amounts;
    },
    // ,
    // getRows(){
    //   return this.rows
    // }
  },
  methods: {
    getSuperInitial(data) {
      if (!data) {
        return data;
      }
      return data.trim()[0].toUpperCase();
    },
    addBlankRow(allrows) {
      this.$emit("addNewRow", allrows);
    },
    addSelected(row) {
      row.isEditMode = true;
    },
    removeSelected(row, header, value) {
      if (header && !isNaN(row[header.rowPropName])) {
        row[header.formattedCurrencyLabel] = format(header.currencyFormat)(
          row[header.rowPropName]
        );
      }
      if (value && value.trim() != "") row.isEditMode = false;
    },
  },
};
</script>

<style lang="scss" module>
@import "@mds/constants";
@import "@mds/typography";

.adl-mds-editable-datatable {
  .textwithimagesection input {
    width: 99%;
    margin-left: $mds-space-half-x;
  }
  .adl-mds-data-table {
    margin-top: 30px;
  }
  .cf-blank-Results {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px;
    width: 320px;
    height: 120px;
    margin: 0 auto;
    margin-top: 32px;
  }
  .textLogoWrapper {
    display: flex;
    align-items: baseline;
  }
  .cf-profileInitialsWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    span + span {
      left: -5px;
      background-color: #808080;
    }
  }
  .cf-profileInitials {
    display: flex;
    height: 24px;
    width: 24px;
    background: $mds-background-color-white;
    border: 1px solid $mds-background-color-light-gray;
    color: black;
    text-align: center;
    border-radius: 50%;
    margin-top: $mds-space-1-x;
    // line-height: 24px;
    font-size: 15px;
    font-weight: bold;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .mds-card__title {
    @include mds-text-crop();
    @include mds-level-5-heading($bold: true);

    border-top: solid 2px transparent; // required for text-crop() reasons
    color: $mds-text-color-primary;
    display: block;
    margin-bottom: $mds-space-1-and-a-half-x;
    margin-top: -2px; // required for text-crop() reasons

    &:last-child {
      margin-bottom: 20px;
    }
  }
  .alignend div {
    justify-content: end;
  }
  .alignend div span {
    text-align: end !important;
  }
  .aligncenter div {
    justify-content: center;
  }
  .GroupWrap {
    border: $mds-border-separator-on-light;
    padding: $mds-space-4-x $mds-space-2-x;
    border-radius: $mds-space-1-x;
    background-color: $mds-background-color-white;
    margin-top: $mds-space-1-x;
  }
  .datatableheading {
    padding-bottom: 20px;
  }
  .tablecell > div {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .tableheader {
    border-bottom: solid 1px #e5e5e5;
  }

  .tableheader > div {
    margin-bottom: 0px !important;
  }
  .tablerow {
    cursor: pointer !important;
  }
  .tablerow:hover .editableCellTxtbox {
    display: block;
  }
  .selectedRow {
    display: block;
  }

  .editableCellTxtbox {
    display: none;
  }

  .tablerow:hover .editableCellLabel {
    display: none;
  }

  .tablerow:hover .totalRowBalanceCell {
    display: block;
  }

  .cf-datatable {
    margin-top: 20px;
    padding: 20px;
  }

  .cf-tag {
    margin-top: 10px;
    text-align: right;
  }

  .cf-tag-inner {
    min-width: auto;
    font-size: 10px;
    text-transform: uppercase;
    line-height: 16px;
    font-weight: bold;
    letter-spacing: 1.67px;
    margin-left: 8px;
    background-color: #00beaf !important;
    color: black !important;
    border: none;
  }
}
</style>
